export default __webpack_public_path__ + "static/media/vault.39d335ce.svg";